import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Services
import { DataService } from '../../services/data.service';
import { FreeTrialService } from '../../services/free-trial.service';

// Model
import { School } from '../../model/school';

enum cancelReason {
	"expensive" = "It's too expensive for my budget",
	"needs" = "It didn't meet my needs",
	"period" = "I only wanted it for the free trial period",
	"usage" = "I didn't understand how to use the product",
	"other" = "Other"
}

@Component({
	selector: 'app-free-trial-cancel',
	templateUrl: './free-trial-cancel.component.html',
	styles: [
		`.fa-check {
			color: green;
			font-size: small;
		}`,
		`.upgraded {
			font-size: larger
		}`
	]
})
export class FreeTrialCancelComponent implements OnInit {

	isLoading: boolean = false;
	isCancelLoading: boolean = false;

	completedCancel: boolean = false;

	reason: string = "";
	otherReason: string = "";
	expectations: string = "";

	private hasEnded: boolean = false;

	constructor(
		private dataSvc: DataService,
		private freeTrialSvc: FreeTrialService,
		private router: Router
	) { }

	// Return enum
	get cancelReasonEnum() {
		return cancelReason;
	}

	get daycareName() {
		return this.dataSvc.daycare ? this.dataSvc.daycare.name: ""
	}

	get passedEndDate(): boolean {
		return this.hasEnded;
	}

	// Set daycare information
	async ngOnInit() {
		this.isLoading = true;

		// Get daycare alias from url
		let url = window.location.href
		let daycareAliasEncoded = this.dataSvc.getQueryStringParams(url, 'ID');
		let daycareAlias = atob(decodeURIComponent(daycareAliasEncoded));
		this.hasEnded = this.dataSvc.getQueryStringParams(url, 'ended') == 'true' ? true: false;

		// Send to error page if no alias
		if (daycareAlias == "") {
			this.isLoading = false;
			this.router.navigate(['error404']);
			return;
		}

		try {
			let daycare = await this.dataSvc.getDaycare(null,daycareAlias, false) as School;
			
			// Verify that the school is a childpilot lite client
			if (daycare && daycare.cpBillingPlan === 'lite' && !daycare.isDeleted) {
				this.dataSvc.daycare = daycare;
			}
			else {
				this.router.navigate(['error404']);
			}
		}
		catch(e) {
			this.router.navigate(['error404']);
			console.log(e);
		}

		this.isLoading = false;
	}

	async btnCancel(): Promise<any> {
		try {
			if (!this.canCancel()) 
				return;

			// Prevent multiple clicks
			if (this.isCancelLoading)
				return;

			this.isCancelLoading = true;
			
			// Use the otherReason field if 'Other' was selected
			let cancelReason = this.reason === 'Other' ? this.otherReason: this.reason;

			// Call API to cancel this school's free trial
			let res = await this.freeTrialSvc.cancelFreeTrial(this.dataSvc.daycare.name, this.dataSvc.daycare.inviteKey, cancelReason, this.expectations, this.dataSvc.daycare.dynamics.accountID);

			// Delete any scheduled emails that are to be sent to this school
			this.freeTrialSvc.deleteFollowUpEmails(this.dataSvc.daycare.name);

			// Send email to daycare director & CP Team
			this.freeTrialSvc.sendCancelConfirmation(this.dataSvc.daycare.name,  this.dataSvc.daycare.inviteKey);
			
			this.isCancelLoading = false;
			this.completedCancel = true;
		}
		catch(e) {
			console.log(e);
			this.isCancelLoading = false;
		}
	}

	canCancel(): boolean {
		if (this.reason === 'Other')
			if (!this.otherReason)
				return false;

		return !!this.reason && !! this.expectations;
	}

	// select a radio button
	activate(key: string) {
		this.reason = this.cancelReasonEnum[key];
	}

	// if the radio button is selected, return an active class
	getActiveClass(key: string) {
		if (this.isChecked(key))
			return 'chosen';

		return '';
	}

	// Determine if the radio button is selected
	isChecked(key: string) {
		return this.cancelReasonEnum[key] === this.reason;
	}
}